import React from 'react'
import PropTypes from 'prop-types'
import { StackView, Spinner } from '@planningcenter/tapestry-react'

const Loading = ({
  isLoading,
  color = 'primary',
  children,
  style,
  ...restProps
}) => {
  if (isLoading) {
    return (
      <StackView
        alignment="center"
        distribution="center"
        width="100%"
        height="100%"
        maxHeight="80vh"
        padding={1}
        style={style}
      >
        <Spinner color={color} thickness={2} {...restProps} />
      </StackView>
    )
  }
  return children
}

Loading.propTypes = {
  isLoading: PropTypes.bool.isRequired,
}

export default Loading
